import styled from 'styled-components';

const PlainButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  outline: inherit;
`;

export default PlainButton;
